var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

/**
 * The proposal launch dialog
 */
Curriculog.ProposalForm.LaunchReviewDialog = (function ($, _, Backbone, LaunchReviewDialog) {

    LaunchReviewDialog = Curriculog.ProposalForm.LaunchDialog.extend({
        template: 'ProposalForm/Form/LaunchReviewDialog.html',
        title: 'Launch Proposal for Review',
        buttons: {
            'Launch Proposal for Review': '_resolve',
            'Cancel': '_reject'
        }

    });

    return LaunchReviewDialog;

})($, _, Backbone, Curriculog.ProposalForm.LaunchReviewDialog || {});

